import { useContext, useEffect, useState } from "react";
import InputRegister from "../../../layouts/ui/InputRegister";
import { IoMdAdd } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { URL } from '../../../utils/validator'
import { DataProvider } from "../../../store/ContextProvider";

const makeEmptySkill = () => ({
    socialName: "",
    url: "",
    description: ""
});

export const Social = ({ candidate }) => {
    const { BeURL, showAlert } = useContext(DataProvider);
    const [social, setSocial] = useState([]);
    const [topInput, setTopInput] = useState(makeEmptySkill());
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState({});

    const validate = () => {
        let newErrors = {};
        if (!topInput.socialName.trim()) {
            newErrors.socialName = "Social profile name is required";
        }
        const urlError = URL(topInput.url);
        if (urlError) {
            newErrors.url = urlError;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        if (Array.isArray(candidate?.socialProfiles)) setSocial(candidate?.socialProfiles);
    }, [candidate?.socialProfiles]);

    const handleChange = (field, value) => {
        setTopInput(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: "" }));
    };

    const handleBlur = (field) => {
        let newErrors = {};
        if (field === "socialName" && !topInput.socialName.trim()) {
            newErrors.socialName = "Social profile name is required";
        }
        if (field === "url") {
            if (!topInput.url.trim()) {
                newErrors.url = "URL is required";
            } else {
                const err = URL(topInput.url);
                if (err) newErrors.url = err;
            }
        }
        setErrors(prev => ({ ...prev, ...newErrors }));
    };

    const handleSubmit = async (method, url) => {
        if (!validate())
            return;

        try {
            const res = await fetch(url, {
                method,
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ social: [topInput] })
            });
            const data = await res.json();
            if (data.success) {
                showAlert(data.message)
                setSocial(data.social)

                handleClear()
                window.location.reload()
            } else {
                showAlert(data.message)
            }
        } catch (err) {
            console.error("Error in social profile:", err);
        }

        setTopInput(makeEmptySkill());
        setEditingId(null);
    };

    const handleAdd = () => handleSubmit("POST", `${BeURL}/candidate-social`);
    const handleUpdate = () => handleSubmit("PUT", `${BeURL}/candidate-social/${editingId}`);
    const handleClear = () => {
        setTopInput(makeEmptySkill());
        setEditingId(null);
        setErrors({});
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this social Information?")) return;
        try {
            const res = await fetch(`${BeURL}/candidate-social-delete/${id}`, {
                method: "DELETE",
                credentials: "include"
            });
            const data = await res.json();
            showAlert(data.message)
            if (data.success) {
                showAlert(data.message)
                setSocial(data.social)
                handleClear()
            }
            else {
                showAlert(data.message)
            }
        } catch (err) {
            console.error("Error in delete social profile", err);
        }
    };

    const handleEdit = (card) => {
        setTopInput({ socialName: card.socialName, url: card.url, description: card.description });
        setEditingId(card._id);
        setErrors({});
    };

    return (
        <div>
            <div className="py-4">
                {/* Input Form */}
                <div className="border-2 rounded-2xl p-4 bg-white shadow-sm mb-4">
                    <div className="flex items-start justify-between mb-3">
                        <h4 className="text-base font-semibold text-slate-800">Create social</h4>
                        <div className="flex gap-2">
                            {editingId ? (
                                <>
                                    <button onClick={handleClear} className="px-3 py-1 rounded underline text-primary-500">Clear</button>
                                    <div onClick={handleUpdate} className="px-2 rounded-lg bg-primary-500 text-white flex items-center gap-1 cursor-pointer">
                                        <FiEdit2 /> <p>Update</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <button onClick={handleClear} className="px-3 py-1 rounded underline text-primary-500">Clear</button>
                                    <div onClick={handleAdd} className="px-2 rounded-lg bg-primary-400 text-white flex items-center gap-1 cursor-pointer">
                                        <IoMdAdd /> <p>Add</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Inputs */}
                    <div className="grid grid-cols-1 md:grid-cols-3 md:gap-3 mt-5">
                        <InputRegister
                            label="Social Profile"
                            mandatory
                            value={topInput.socialName}
                            onChange={e => handleChange("socialName", e.target.value)}
                            onBlur={() => handleBlur("socialName")}
                            placeholder="Social name"
                            type="text"
                            className="w-full"
                            error={errors.socialName}
                            border={1}
                        />
                        <InputRegister
                            label="Link"
                            mandatory
                            value={topInput.url}
                            onChange={e => handleChange("url", e.target.value)}
                            onBlur={() => handleBlur("url")}
                            placeholder="Profile link"
                            type="url"
                            className="w-full"
                            error={errors.url}
                            border={1}
                        />
                        <div className="flex flex-col gap-1 md:col-span-3">
                            <label className="text-sm text-slate-600 font-medium">Description</label>
                            <textarea
                                value={topInput.description}
                                onChange={e => handleChange("description", e.target.value)}
                                placeholder="Enter description..."
                                className="w-full p-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                                rows={4}
                            />
                        </div>
                    </div>
                </div>

                {/* Social List */}
                <div className="mt-3 space-y-4 bg-white rounded-2xl px-2 py-3">
                    <p>social <span>({social.length})</span></p>
                    {social.length === 0 && (
                        <div className="text-sm text-red-500 italic animate-pulse">
                            No social yet. Use the top input to add.
                        </div>
                    )}

                    <div className="relative">
                        <div id="expScroll" className="flex gap-4 overflow-x-auto px-6">
                            {social.map((card, idx) => (
                                <div key={idx} className="bg-white border rounded-lg flex-shrink-0 shadow-md p-4 w-full sm:w-[48%] md:w-[30%]">
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-xs text-slate-400 capitalize">social profile</p>
                                            <p className="font-medium text-slate-800 capitalize">{card.socialName || "-"}</p>
                                        </div>
                                        <div className="flex gap-2">
                                            <button onClick={() => handleEdit(card)} className="text-slate-600 hover:text-blue-600"><FiEdit2 /></button>
                                            <button onClick={() => handleDelete(card._id)} className="text-red-500 hover:text-red-700"><MdDeleteOutline /></button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xs text-slate-400">Link</p>
                                        {card.url ? (
                                            <a
                                                href={card.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-500 underline cursor-pointer"
                                                title={card.url}
                                            >
                                                Click here
                                            </a>
                                        ) : (
                                            <p className="text-gray-400">-</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-end mt-1 gap-2 text-xs">
                            <p className="text-[10px] text-slate-400 italic">Use ← and → buttons to scroll</p>
                            <button onClick={() => document.getElementById("expScroll").scrollBy({ left: -200, behavior: "smooth" })}>◀</button>
                            <button onClick={() => document.getElementById("expScroll").scrollBy({ left: 200, behavior: "smooth" })}>▶</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
